import { forwardRef, useContext, useMemo } from 'react';
import { ScCompleteUserGameData } from './styled';
import { useTranslation } from 'react-i18next';
import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplate } from 'components/ModalTemplate';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { CommonUtilsContext } from 'contexts/commonUtils';
import { CompleteProfileForm } from './CompleteProfileForm';

type CompleteUserGameDataModalProps = ModalDefaultProps & {
  gameProvider?: string;
  redirect?: string;
};

export const CompleteProfileModal = forwardRef<
  HTMLDivElement,
  CompleteUserGameDataModalProps
>(({ gameProvider, redirect, onClose }, ref) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['glossary', 'personal', 'profile', 'common']);
  const { isMobileS } = useContext(CommonUtilsContext);

  const modalSettings: ModalTemplateSettings = useMemo(() => {
    return isMobileS
      ? {
          type: 'mobile',
          mode: {
            type: 'default',
          },
        }
      : {
          type: 'desktop',
          size: 'large',
          mode: {
            type: 'default',
          },
        };
  }, [isMobileS]);

  return (
    <ModalTemplate ref={ref} onClose={onClose} settings={modalSettings}>
      <ScCompleteUserGameData>
        <div className="header">
          <h2 className={`title ${language}`}>
            {t('common:userGameData.title')}
          </h2>
          <p className="description">{t('common:userGameData.description')}</p>
        </div>

        <CompleteProfileForm
          gameProvider={gameProvider}
          redirect={redirect}
          onClose={onClose}
        />
      </ScCompleteUserGameData>
    </ModalTemplate>
  );
});
